<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>


<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
      <button (click)="createStorage()" mat-button color="primary">New Storage</button>
    </div>

    <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar>
    <table (matSortChange)="doSortStorage($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      multiTemplateDataRows matSort>

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- Position Column -->
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
        <td *matCellDef="let element" mat-cell> {{element.id}} </td>
      </ng-container>

      <!-- Total space Column -->
      <ng-container matColumnDef="totalSpace">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Total space</th>
        <td *matCellDef="let element" mat-cell> {{element.totalSpace}} MB</td>
      </ng-container>

      <!-- Files count Column -->
      <ng-container matColumnDef="filesCount">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Files count</th>
        <td *matCellDef="let element" mat-cell> {{element.filesCount}} </td>
      </ng-container>

      <!-- Usage Column -->
      <ng-container matColumnDef="usage">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Usage</th>
        <td *matCellDef="let element" mat-cell> {{element.usage|bytes}} </td>
      </ng-container>

      <!-- Testbed Column -->
      <ng-container matColumnDef="testbed">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Testbed</th>
        <td *matCellDef="let element" mat-cell> {{element.testbed?.identifier}} </td>
      </ng-container>

      <!-- Bucket Id Column -->
      <ng-container matColumnDef="bucketId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Bucket Id</th>
        <td *matCellDef="let element" mat-cell> {{element.bucketId}} </td>
      </ng-container>

      <!-- Action -->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element" mat-cell class="text-right">
          <ng-container *ngIf="!disabledItemId.includes(element.id); else loadingItem">
            <button (click)="details(element)" [disabled]="disabled" mat-icon-button matTooltip="Show details">
              <mat-icon>visibility</mat-icon>
            </button>
            <button (click)="editStorage(element)" [disabled]="disabled" mat-icon-button matTooltip="Edit Storage">
              <mat-icon>edit</mat-icon>
            </button>
            <button *awIsInAnyRole="[roles.admin]" (click)="deleteStorage(element)" [disabled]="disabled"
              mat-icon-button matTooltip="Delete Storage">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns:  displayedColumns" mat-row></tr>
      <!--      <tr *matRowDef="let row; columns: ['expandedDetail']"-->
      <!--          [fxShow]="expandedContractEventsHistory?.id === row.id" mat-row></tr>-->


      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="displayedColumns.length" class="mat-cell text-center">
          No storage found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorStorage [fxShow]="dataSource && dataSource.data.length > 10" class="mat-elevation-z1"
    [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons></mat-paginator>
</div>